<template>
  <div>
    <template v-if="details">
      <v-layout wrap>
        <v-flex
          md4
          xs12
        >
          <v-card
            class="ma-1"
          >
            <v-container>
              <div>
                <span class="text-caption">{{ $t('tasks.state.name') + ': ' }}</span>
                {{ details.state | taskState }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.priority.name') + ': ' }}</span>
                {{ details.priority | taskPriority }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.assigned_user') + ': ' }}</span>
                {{ details.assigned_user | fullName }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.time_spent') + ': ' }}</span>
                {{ details.time_entries | timeEntriesSumHumanize }}
              </div>
              <v-divider
                class="my-2"
              />
              <div>
                <span class="text-caption">{{ $t('tasks.supplier') + ': ' }}</span>
                {{ details.supplier | supplierBrief }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.delivery_number') + ': ' }}</span>
                {{ details.delivery_number || '-' }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.invoice_number') + ': ' }}</span>
                {{ details.invoice_number || '-' }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.stockLoading.loadTo') + ': ' }}</span>
                {{ (stockDetails !== null ? (stockDetails.name + ' / ') : '') + details.subordinate_stock.name }}
              </div>
              <div>
                <span class="text-caption"> {{ $t('tasks.strictMode.label') + ': ' }}</span>
                {{ $t('tasks.strictMode.' + details.strict_mode) }}
                <v-tooltip right>
                  <template #activator="{ on }">
                    <span v-on="on"><v-icon>$info</v-icon></span>
                  </template>
                  <span>{{ $t('tasks.stockLoading.strictHint.' + details.strict_mode) }}</span>
                </v-tooltip>
              </div>
              <div v-show="details.description">
                <span class="text-caption">{{ $t('tasks.description') + ': ' }}</span>
                {{ details.description }}
              </div>
              <v-divider
                class="my-2"
              />
              <EntityHistory :changes="details" />
            </v-container>
          </v-card>
        </v-flex>
        <v-flex
          v-show="details.notes.length > 0"
          md4
          xs12
        >
          <Notes :notes="details.notes" />
        </v-flex>
        <v-flex
          md4
          xs12
        >
          <TaskAttachments
            :attachments="details.attachments"
          />
        </v-flex>
      </v-layout>
      <TaskItemsCard
        v-if="ready"
        :api="API"
        :card-type="TaskItemsCardType.ASSIGNMENT"
        :is-single="false"
        :items="itemsToMove"
        :task-info="taskInfo"
        task-lang-path="stockLoading."
        allow-batch-print
      />
    </template>
    <template v-else>
      <v-progress-linear
        indeterminate
      />
    </template>
  </div>
</template>

<script>
    import {TaskDeliveryAcceptAPI} from "@/api/TaskDeliveryAcceptAPI";
    import TaskAttachments from "@/app/tasks/components/TaskAttachments.component";
    import Notes from "@/app/tasks/components/TaskNotes.component";
    import EntityHistory from "@/app/components/EntityHistory.component";
    import {StockAPI} from "@/api/StockAPI";
    import TaskItemsCard from "@/app/tasks/components/taskItemsCard/TaskItemsCard.component";
    import {TaskItemsCardType} from "@/enum/task_items_card_type";
    import {TaskFetchItemsMixin} from "@/app/mixins/TaskFetchItemsMixin";
    import {CreatedOrActivatedMixin} from "@/app/mixins/CreatedOrActivatedMixin";
    import {TaskStockLoadingAPI as API} from "@/api/TaskStockLoadingAPI";

    export default {
        name: "StockLoadingAssignment",
        components: {EntityHistory, Notes, TaskAttachments, TaskItemsCard},
        mixins: [CreatedOrActivatedMixin, TaskFetchItemsMixin],
        props: {
            taskInfo: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            deliveryAcceptDetails: null,
            stockDetails: null,
            items: [],
            ready: false,
            TaskItemsCardType: TaskItemsCardType,
            API: API
        }),
        computed: {
            details: function () {
                return this.taskInfo.details;
            },
            itemsToMove: function () {
                return this.items.filter(item => item.quantity_to_move !== 0);
            }
        },
        createdOrActivated: function (lifeCycleHook) {
            if (this.details.delivery_accept_id && this.deliveryAcceptDetails === null) {
                this.fetchDeliveryAcceptDetails();
            }
            if (this.details.subordinate_stock && this.stockDetails === null) {
                this.fetchStockDetails();
            }
            if (lifeCycleHook === this.LifeCycleHook.CREATED) {
                this.fetchItems({initial: true}).then(() => this.ready = true).catch(this.snack);
            } else {
                this.fetchItems().catch(this.snack);
            }
        },
        methods: {
            fetchDeliveryAcceptDetails: function () {
                TaskDeliveryAcceptAPI.get(this.details.delivery_accept_id)
                    .then(response => {
                        this.deliveryAcceptDetails = response.data;
                    }).catch(this.snack);
            },
            fetchStockDetails: function () {
                StockAPI.get(this.details.subordinate_stock.stock_id)
                    .then(response => {
                        this.stockDetails = response.data;
                    }).catch(this.snack);
            }
        }
    };
</script>

<style scoped>

</style>
